__turbopack_context__.v({
  "active": "subNavBar-module-scss-module__erGO2G__active",
  "close": "subNavBar-module-scss-module__erGO2G__close",
  "dropdownItem": "subNavBar-module-scss-module__erGO2G__dropdownItem",
  "dropdownMenu": "subNavBar-module-scss-module__erGO2G__dropdownMenu",
  "dropdownModal": "subNavBar-module-scss-module__erGO2G__dropdownModal",
  "icon": "subNavBar-module-scss-module__erGO2G__icon",
  "list": "subNavBar-module-scss-module__erGO2G__list",
  "navBar": "subNavBar-module-scss-module__erGO2G__navBar",
  "navigation": "subNavBar-module-scss-module__erGO2G__navigation",
  "open": "subNavBar-module-scss-module__erGO2G__open",
  "search": "subNavBar-module-scss-module__erGO2G__search",
  "showIcon": "subNavBar-module-scss-module__erGO2G__showIcon",
  "subnavBar": "subNavBar-module-scss-module__erGO2G__subnavBar",
  "wrapper": "subNavBar-module-scss-module__erGO2G__wrapper",
});
